<template>
    <div style="margin-bottom: 10px;">
        <VueDatePicker format="dd-MM-yyyy HH:mm:ss" locale="it-IT" v-model="dates"></VueDatePicker>
    </div>
</template>

<script>
    import VueDatePicker from "@vuepic/vue-datepicker";
    export default {
        name: 'form-element-datetime-picker',
        props: {
            value:{type:String},
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }}
        },
        data(){
            return {
                dates: "",
            }
        },
        watch:{
            dates: {
                deep: true,
                handler(){
                    this.$emit('input', this.dates);
                }
            }
        },
        mounted(){
            if(this.value != null)
                this.dates = this.value
        },
        components: {VueDatePicker }
    }
</script>